'use client'

import { useProductFlags } from '@/screens/Product/hooks/use-product-flags'
import { useProduct } from '@/screens/Product/hooks/useProduct'

import { DolyameWidget } from '@/widgets/dolyame-widget'

import { YandexPayWidget, YaPaySplitFastButton } from '@/features/YaSplit'

import { DISCOUNT_ORDER_SOURCE } from '@/shared/lib/const/order-source'

import panelCl from '../../ui/product-main/product-panel/product-panel.module.scss'

export const DiscountProductPaymentWidgets = (): JSX.Element | null => {
	const { product } = useProduct()
	const { isShowYandexSplitWidget, isPriceUnderLimit, showSplit, SHOW_DOLYAME, isInStock, productIsInStock } =
		useProductFlags()

	if (!isInStock || !productIsInStock || product.ID == null) return null

	const showYandexSplitWidget = showSplit && isShowYandexSplitWidget && isPriceUnderLimit
	const showYandexSplitButton = showSplit && isShowYandexSplitWidget

	return (
		<>
			{SHOW_DOLYAME && <DolyameWidget />}
			{showYandexSplitWidget && (
				<section className={panelCl.section__litleMargin}>
					<div className={panelCl.yaPay}>
						<YandexPayWidget id={product.ID} price={product.PRICE.VALUE} merchantKind="discount" />
					</div>
				</section>
			)}
			{showYandexSplitButton && (
				<div className={panelCl.yaPayButton}>
					<YaPaySplitFastButton id={product.ID} orderSource={DISCOUNT_ORDER_SOURCE} />
				</div>
			)}
		</>
	)
}
